import React, { useState } from 'react';
import { toast } from 'sonner';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      toast.success('נרשמת! דרופ הבא קודם אצלך 🔥');
      setEmail('');
    }
  };
  return <section className="py-24 bg-black text-white brutal-border border-l-0 border-r-0 border-b-0" data-id="element-129">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-130">
        <div className="inline-block bg-acid text-black font-black text-xl px-4 py-1 mb-6 brutal-border rotate-2" data-id="element-131">
          אל תישאר מאחור
        </div>

        <h2 className="text-5xl md:text-7xl font-black mb-8 leading-tight" data-id="element-132">
          הצטרף ל<span className="text-magenta" data-id="element-133">מחתרת</span>
        </h2>

        <p className="text-2xl font-bold mb-12 text-gray-300" data-id="element-134">
          קבל גישה מוקדמת לדרופים, הנחות סודיות והזמנות למסיבות סגורות.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 justify-center max-w-2xl mx-auto" data-id="element-135">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="האימייל שלך כאן..." required className="flex-grow bg-white text-black text-2xl font-bold p-4 brutal-border focus:outline-none focus:ring-4 focus:ring-electric placeholder-gray-500" dir="rtl" data-id="element-136" />
          <button type="submit" className="brutal-btn bg-electric text-white text-2xl px-8 py-4 hover:bg-magenta whitespace-nowrap" data-id="element-137">
            הכנס אותי
          </button>
        </form>
      </div>
    </section>;
}